// extracted by mini-css-extract-plugin
export var iconsContainer = "videoText-module--iconsContainer--wAxcN";
export var laptopAndVideoWrapper = "videoText-module--laptopAndVideoWrapper--aSn1N";
export var modalButton = "videoText-module--modalButton--pHo6v";
export var offset = "videoText-module--offset--bTwxp";
export var preview = "videoText-module--preview--Ab6uN";
export var right = "videoText-module--right--MO5xH";
export var sbShowMain = "videoText-module--sb-show-main--YQpYb";
export var textWrapper = "videoText-module--textWrapper--2SGLm";
export var video = "videoText-module--video--ikoK1";
export var videoWrapper = "videoText-module--videoWrapper--v5ADh";
export var wrapper = "videoText-module--wrapper--fC6HJ";